// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Heading_subtitle__FOsG_","slide-in-out":"Heading_slide-in-out__g6XvW","fade-in-out":"Heading_fade-in-out__d0D7G"};